import * as Types from '../../../../../../../../../graphql/generated-base';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetRecommendedCatalogCategoriesQueryVariables = Types.Exact<{
  eventId?: Types.InputMaybe<Types.Scalars['ID']>;
  storefront?: Types.InputMaybe<Types.CatalogStorefront>;
}>;

export type GetRecommendedCatalogCategoriesQuery = {
  __typename?: 'Query';
  recommendCatalogHomeSections: {
    __typename?: 'ProductCatalogPageSectionContainer';
    id?: string | null;
    sections: Array<{
      __typename?: 'ProductCatalogPageSection';
      id: string;
      displayType: string;
      catalogEntities: Array<
        | { __typename?: 'ProductCatalogEntityBrand' }
        | {
            __typename: 'ProductCatalogEntityCategory';
            id: string;
            catalogCategoryData?: {
              __typename?: 'ProductCatalogCategory';
              id: string;
              title: string;
              publicUrlPath: string;
              isFeatured?: boolean | null;
              browseMoreBanner?: { __typename?: 'ProductCatalogCategoryBrowseBannerMore'; image?: { __typename?: 'Photo'; id: string; url: string } | null } | null;
              subCategories: Array<{
                __typename?: 'ProductCatalogCategory';
                id: string;
                title: string;
                publicUrlPath: string;
                directItemCount: number;
                isFeatured?: boolean | null;
                spotlight?: {
                  __typename?: 'ProductCatalogCategorySpotlight';
                  title?: string | null;
                  videoUrl?: string | null;
                  image?: { __typename?: 'Photo'; id: string; url: string } | null;
                  videoPlaceholder?: { __typename?: 'Photo'; id: string; url: string } | null;
                } | null;
              }>;
            } | null;
          }
        | { __typename?: 'ProductCatalogEntityCuration' }
        | { __typename?: 'ProductCatalogEntityItem' }
        | { __typename?: 'ProductCatalogEntityItemGroup' }
      >;
    }>;
  };
};

export const GetRecommendedCatalogCategoriesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRecommendedCatalogCategories' },
      variableDefinitions: [
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'storefront' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CatalogStorefront' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendCatalogHomeSections' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'storefront' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'storefront' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sections' },
                  arguments: [
                    { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1' } },
                    { kind: 'Argument', name: { kind: 'Name', value: 'offset' }, value: { kind: 'IntValue', value: '2' } },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'catalogEntities' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogEntityCategory' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'catalogCategoryData' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'browseMoreBanner' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'image' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isFeatured' } },
                                        {
                                          kind: 'Field',
                                          alias: { kind: 'Name', value: 'subCategories' },
                                          name: { kind: 'Name', value: 'children' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'directItemCount' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'isFeatured' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'spotlight' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'image' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                        ],
                                                      },
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'videoUrl' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'videoPlaceholder' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRecommendedCatalogCategoriesQuery__
 *
 * To run a query within a React component, call `useGetRecommendedCatalogCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedCatalogCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedCatalogCategoriesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      storefront: // value for 'storefront'
 *   },
 * });
 */
export function useGetRecommendedCatalogCategoriesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetRecommendedCatalogCategoriesQuery, GetRecommendedCatalogCategoriesQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetRecommendedCatalogCategoriesQuery, GetRecommendedCatalogCategoriesQueryVariables>(GetRecommendedCatalogCategoriesDocument, baseOptions);
}
export function useGetRecommendedCatalogCategoriesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRecommendedCatalogCategoriesQuery, GetRecommendedCatalogCategoriesQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetRecommendedCatalogCategoriesQuery, GetRecommendedCatalogCategoriesQueryVariables>(GetRecommendedCatalogCategoriesDocument, baseOptions);
}
export type GetRecommendedCatalogCategoriesQueryHookResult = ReturnType<typeof useGetRecommendedCatalogCategoriesQuery>;
export type GetRecommendedCatalogCategoriesLazyQueryHookResult = ReturnType<typeof useGetRecommendedCatalogCategoriesLazyQuery>;
export type GetRecommendedCatalogCategoriesQueryResult = Apollo.QueryResult<GetRecommendedCatalogCategoriesQuery, GetRecommendedCatalogCategoriesQueryVariables>;
